import { Box, SxProps, Theme } from '@mui/material';
import Chart, { Props } from 'react-apexcharts';

export interface ESApexChartProps {
  chartData: Props;
  sx?: SxProps<Theme>;
}

export const ESApexChart = ({ chartData, sx }: ESApexChartProps) => {
  return (
    <Box sx={sx}>
      <Chart {...chartData} />
    </Box>
  );
};
